module.exports = __webpack_public_path__ + "assets/img/warrior-name-b2075a3f.png";